/** Who an HPC package is sold to (hpc-management-service). */
export enum HpcPackageAudience {
    PERSONAL = 'PERSONAL',
    ORGANIZATION = 'ORGANIZATION',
}

/** Whether an organization can be registered under an email domain (data-service domain check). */
export enum HpcOrgDomainStatus {
    VALID = 'VALID',
    INVALID_FORMAT = 'INVALID_FORMAT',
    /** A public mailbox provider such as gmail.com. */
    FREE_EMAIL_DOMAIN = 'FREE_EMAIL_DOMAIN',
    /** The login email is not on this domain. */
    EMAIL_DOMAIN_MISMATCH = 'EMAIL_DOMAIN_MISMATCH',
    /** An organization order on this domain has been paid; the domain is taken for good. */
    ALREADY_REGISTERED = 'ALREADY_REGISTERED',
}
